import { BULK_EVENT_SETTINGS_FIELD_LABELS } from '@blocktickets/shared-utils'

import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import Table from 'react-bootstrap/Table'

import { exportBulkSettingsCsv } from './bulkSettingsClient'

const GROUPS = [
  ['updated', 'Updated', 'success'],
  ['skipped', 'Skipped', 'warning'],
  ['failed', 'Failed', 'danger'],
]

const REASON_LABELS = {
  validation: 'Validation',
  authorization: 'Authorization',
  business_rule: 'Business rule',
  locked: 'Business rule',
  unexpected: 'Unexpected error',
  concurrent_update: 'Unexpected error',
  not_found: 'Not found',
  deleted: 'Deleted',
  unchanged: 'Unchanged',
}

function fieldLabel(field) {
  return BULK_EVENT_SETTINGS_FIELD_LABELS[field] || field
}

export default function BulkEventSettingsResults({ result, onDismiss }) {
  if (!result) return null

  const counts = {
    updated: result.updated?.length || 0,
    skipped: result.skipped?.length || 0,
    failed: result.failed?.length || 0,
  }

  return (
    <Card body className="card--md mt-4" data-testid="bulk-settings-results">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <Card.Title as="h2" className="mb-0">
          Bulk edit results
        </Card.Title>
        <div className="d-flex gap-2">
          <Button
            size="sm"
            variant="outline-light"
            onClick={() => exportBulkSettingsCsv(result)}
          >
            Export results
          </Button>
          <Button size="sm" variant="outline-light" onClick={onDismiss}>
            Dismiss
          </Button>
        </div>
      </div>
      <p>
        Updated {counts.updated}. Skipped {counts.skipped}. Failed {counts.failed}.
      </p>
      {GROUPS.map(([key, title]) => (
        <section key={key} className="mb-4">
          <h3 className="h5">{title}</h3>
          {counts[key] === 0 ? (
            <p className="text-muted small mb-0">None.</p>
          ) : (
            <Table responsive size="sm">
              <thead>
                <tr>
                  <th>Event</th>
                  <th>Reason</th>
                  <th>Updated fields</th>
                </tr>
              </thead>
              <tbody>
                {result[key].map((item) => (
                  <tr key={`${key}-${item.eventUUID}`}>
                    <td>{item.eventName || item.eventUUID}</td>
                    <td>
                      {REASON_LABELS[item.reasonCode] ? (
                        <span className="d-block small text-muted">
                          {REASON_LABELS[item.reasonCode]}
                        </span>
                      ) : null}
                      {item.reason}
                    </td>
                    <td>
                      {(item.updatedFields || []).map(fieldLabel).join(', ') ||
                        '—'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </section>
      ))}
    </Card>
  )
}
